module.exports = "/_next/static/images/06f7be429753010915012fa8aa08707f-locked-deposits@1x.jpg";